// src/components/PdfViewer.jsx
import React from 'react';
import { useEffect, useRef } from 'react';
import * as pdfjsLib from 'pdfjs-dist';

// Point worker to the installed package
pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.6.347/pdf.worker.min.js';

export default function PdfViewer({ url }) {
    const containerRef = useRef(null);

    useEffect(() => {
        if (!url || !containerRef.current) return;

        const container = containerRef.current;
        container.innerHTML = '';

        const loadPdf = async () => {
            console.log('Loading PDF from:', url);
            const pdf = await pdfjsLib.getDocument({ url, withCredentials: false }).promise;
            console.log('PDF loaded, pages:', pdf.numPages);
            for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
                const page = await pdf.getPage(pageNum);
                const viewport = page.getViewport({ scale: 1.5 });
                console.log('Rendering page:', pageNum);
                const canvas = document.createElement('canvas');
                canvas.height = viewport.height;
                canvas.width = viewport.width;
                canvas.style.display = 'block';
                canvas.style.margin = '0 auto 10px';
                canvas.style.maxWidth = '100%';
                canvas.style.boxShadow = '0 2px 8px rgba(0,0,0,0.3)';
                canvas.style.background = 'white';

                container.appendChild(canvas);

                await page.render({
                    canvasContext: canvas.getContext('2d'),
                    viewport,
                }).promise;
            }
        };

        loadPdf().catch(console.error);
    }, [url]);

    return (
        <div
            ref={containerRef}
            style={{
                background: '#525659',
                padding: '10px',
                height: '100%',
                overflowY: 'auto',
            }}
        />
    );
}
